import { postV2ApiCompanyIdUsersUserIdManagerAssociations } from 'src/client/spendesk-api';
import { type PostV2ApiCompanyIdUsersUserIdManagerAssociationsResponseOK } from 'src/client/spendesk-api-types';

export const postUpdateManagerAssociation = async ({
  companyId,
  userId,
  managerId,
}: {
  companyId: string;
  userId: string;
  managerId: string | null;
}): Promise<PostV2ApiCompanyIdUsersUserIdManagerAssociationsResponseOK> => {
  const response = await postV2ApiCompanyIdUsersUserIdManagerAssociations({
    body: { data: { managerId } },
    path: { companyId, userId },
  });
  if (response.statusCode === 200) {
    return response.body;
  }

  throw new Error('Updating manager association failed');
};
